__turbopack_context__.v({
  "footer": "footer-module-scss-module__wXQHpq__footer",
});
